import { render, staticRenderFns } from "./delivered.vue?vue&type=template&id=1b925bc6&"
import script from "./delivered.js?vue&type=script&lang=js&"
export * from "./delivered.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports